import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { IconChevronLeft12, IconChevronLeft16, IconChevronRight12, IconChevronRight16 } from '@cian/ui-kit/icons';
import classNames from 'classnames';
import * as React from 'react';
import { useSliderContext } from '../../utils/sliderContext';
import * as styles from './Buttons.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Buttons = function Buttons(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'S' : _ref$size;

  var _useSliderContext = useSliderContext(),
      scrollPrev = _useSliderContext.scrollPrev,
      scrollNext = _useSliderContext.scrollNext;

  var ArrowLeft = React.useMemo(function () {
    switch (size) {
      case 'S':
        return IconChevronLeft12;

      case 'M':
        return IconChevronLeft16;
    }
  }, [size]);
  var ArrowRight = React.useMemo(function () {
    switch (size) {
      case 'S':
        return IconChevronRight12;

      case 'M':
        return IconChevronRight16;
    }
  }, [size]);
  var handlePrevClick = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    scrollPrev();
  }, [scrollPrev]);
  var handleNextClick = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    scrollNext();
  }, [scrollNext]);
  return React.useMemo(function () {
    return /*#__PURE__*/_jsxs("div", {
      className: classNames(styles['container'], _defineProperty({}, styles['container--size-m'], size === 'M')),
      children: [/*#__PURE__*/_jsx("button", {
        onClick: handlePrevClick,
        title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(ArrowLeft, {
            display: "block",
            color: "white_100"
          })
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleNextClick,
        title: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(ArrowRight, {
            display: "block",
            color: "white_100"
          })
        })
      })]
    });
  }, [ArrowLeft, ArrowRight, handleNextClick, handlePrevClick, size]);
};